import { QFlow } from "./QFlow";

import LogicNode from "./LogicNode";
import FormNode from "./FormNode";

// Production path
var jsonRequest = new Request('https://www.smhn.org.uk/finder/getJSON.ajax.php');

// Local path
//var jsonRequest = new Request('http://www.smhn.alex.local/finder/getJSON.ajax.php');

var services = null;

// Promise JSON data
fetch(jsonRequest)
    .then((response) => response.json())
    .then((data) => {
        services = data;

        for (const service of services) {
            for(let prop in service) {
                let instRegex = /^(Inst)|^(Group)|^(Stage)/;
                if(instRegex.test(prop)) {
                    service[prop] = parseInt(service[prop]);
                }
            }
        }

        calculatePriority(services);
        setStageButtonClickEvents();

        // Set urgent service card click events
        const urgentContainer = document.querySelector("#exit_urgent");
        
        //console.log("Loaded services", services);

        // TODO: Get rid of loading message :)

        flow.start();

        // For debugging
        /*
        flow.goto(exit_result, {
            who: "me",
            urgent: "no",
            age: "u16",
            school: "none",
            camhs: "yes",
            gender: "male",
            drug: "no",
            parent: "no",
            care: "yes"
        });
        */
    })
    .catch(console.error);

var qs = (sel) => {
    return document.querySelector(sel);
}

var flow = new QFlow();

/**
 * Set up nodes
 */

var intro = flow.add(new FormNode(qs('#intro'), {nextStr: "Start", allowBack: false}));

var q_confidential = flow.add(new FormNode(qs('#q_confidential'), {}));

var q_who = flow.add(new FormNode(qs('#q_who'), {}));

var gate_who = flow.add(new LogicNode( (state) => {
    if(state.who == 'me') {
        changeGrammar("fp");
    } else {
        changeGrammar("tp");
    }
}));

var q_urgent = flow.add(new FormNode(qs('#q_urgent'), {}));

var gate_urgent = flow.add(new LogicNode( (state) => {
    if(state.urgent == 'yes') {
        appendResult(services);
        setActiveResults(4);
        return exit_result;
    } else {
        return q_age;
    }
}));

var q_age = flow.add(new FormNode(qs('#q_age'), {}));

var gate_age = flow.add(new LogicNode( (state) => {
    if(state.age == 'o25') {
        return exit_elderly;
    } else if(state.age == '1625') {
        return q_school;
    } else if(state.age == 'u16') {
        return exit_young;
    }
}));

var exit_young = flow.add(new FormNode(qs('#exit_young'), {terminal: true}));

var exit_elderly = flow.add(new FormNode(qs('#exit_elderly'), {terminal: true}));

var q_school = flow.add(new FormNode(qs('#q_school'), {}));

var gate_camhs = flow.add(new LogicNode( (state) => {
    // Needn't ask about CAMHS for university students
    if(state.school == 'uos' || state.school == 'solent') {
        return q_gender;
    } else {
        return q_camhs;
    }
}));

var q_camhs = flow.add(new FormNode(qs('#q_camhs'), {}));

// var q_soton = flow.add(new FormNode(qs('#q_soton'), {}));

var q_gender = flow.add(new FormNode(qs('#q_gender'), {}));

var q_drug = flow.add(new FormNode(qs('#q_drug'), {}));

var q_parent = flow.add(new FormNode(qs('#q_parent'), {}));

var q_care = flow.add(new FormNode(qs('#q_care'), {}));

var q_thanks = flow.add(new FormNode(qs('#q_thanks'), {}));

var q_roadmap = flow.add(new FormNode(qs('#q_roadmap'), {}));

var resultNode;

var exit_result = flow.add(resultNode = new FormNode(qs('#exit_result'), {terminal: true}));

resultNode.oldGo = resultNode.go;

resultNode.go = function(state, then) {
    //console.log(this);

    this.oldGo(state, then);

    // Filter services, only return relevant
    var fs = filterServices(state, services);

    // Shuffle services with Fisher-Yates before sort to make displaying orgs fairer!
    function shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          const temp = array[i];
          array[i] = array[j];
          array[j] = temp;
        }
        return array;
    }

    const shuffledArray = shuffleArray(fs);

    shuffledArray.sort((a, b) => {
        //console.log(a, a.priority, b, b.priority);
        return b.priority - a.priority
    });

    //console.log(fs);

    // TO DO need a placeholder for empty stage containers - maybe also grey out stage button?
    // Create cards
    appendResult(fs);

    // Set result card click events
    let resultCards = document.querySelector("#exit_result");
}

var exit_generic = flow.add(new FormNode(qs('#exit_generic'), {terminal: true}));

var exit_urgent = flow.add(new FormNode(qs('#exit_urgent'), {terminal: true}));

/**
 * Helper functions
 */

// Change first or third person grammar active class
function changeGrammar(grammar) {
    let body = qs("body");
    body.className = grammar;
}

// Loops through array of service flags, adds a priority score
function calculatePriority(services) {
    for (const service of services) {
        service.priority = 0;
        
        const flagArray = [
            service.Group_Alcohol,
            service.Group_CAMHS,
            service.Group_Drug,
            service.Group_Female,
            service.Group_LookedAfter,
            service.Group_Male,
            service.Group_Parent,
            service.Inst_CityCollege,
            service.Inst_ItchenCollege,
            service.Inst_RichardTaunton,
            service.Inst_Solent,
            service.Inst_UoS
        ];

        for (const i in flagArray) {
            if(flagArray[i] > 0) {
                service.priority += 10;
            }
        }
    }
}

// Loops through all services, returns array of just the applicable ones
function filterServices(state, services) {
    let out = [];

    for (const service of services) {
        //console.log(service.Organisation.Name, checkService(state, service));
        if (checkService(state, service)) {
            out.push(service);
        }
    }

    return out;
}

// Checks flags on a service against answers stored in state, returns false if
function checkService(state, iservice) {
    let service = {};
    Object.assign(service, iservice);

    // Filter age
    if(state.age === "u16") {
        if(service.MinAge > 15) {
            console.log("Users age " + state.age + " is lower than service minimum " + service.MinAge);
            return false;
        }
    } else if (state.age === "1625") {
        if(service.MaxAge < 16 && !service.MaxAge == 0) {
          console.log("Users age " + state.age + " is higher than service maximum " + service.MaxAge);
          return false;
        }
    } else {
        throw "Unknown age " + state.age;
    }

    // Filter gender
    if(state.gender === "male") {
        if(service.Group_Female == 1) {
            console.log("Users gender " + state.gender + " does not match service female gender requirement");
            return false;
        } 
    } else if(state.gender === "female") {
        if(service.Group_Male == 1) {
            console.log("Users gender " + state.gender + " does not match service male gender requirement");
            return false;
        } 
    } else if(state.gender === "other" || state.gender === "null") {

    } else {
        throw "Unknown gender " + state.gender;
    }

    // Filter schools

    // Create virtual restriction for case of no schools
    service.Inst_None = 0;
    let i = 0;

    for (const key in service) {
        if(key.substring(0,4) === "Inst") {
            i += service[key];
        }
    }

    if(i === 0) {
        for (const key in service) {
            if(key.substring(0,4) === "Inst") {
                service[key] = 1;
            }
        }
    }

    if(typeof state.school === "undefined" || state.school === "none") {
        if(service.Inst_None != 1) {
            return false;
        } 
    } else if(state.school === "city") {
        if(service.Inst_CityCollege != 1) {
            return false;
        }
    } else if(state.school === "itchen") {
        if(service.Inst_ItchenCollege != 1) {
            return false;
        }
    } else if(state.school === "richard") {
        if(service.Inst_RichardTaunton != 1) {
            return false;
        }
    } else if(state.school === "uos") {
        if(service.Inst_UoS != 1) {
            return false;
        }
    } else if(state.school === "solent") {
        if(service.Inst_Solent != 1) {
            return false;
        }
    } else {
        throw "Unknown school " + state.school;
    }

    // To do add Camhs database values
    // Filter CAMHS
    if(state.camhs === "no") {
        if(service.Group_CAMHS == 1) {
            console.log("Users CAMHS eligibility " + state.camhs + " does not match service CAMHS requirement");
            return false;
        }
    }

    // Filter drugs
    if(state.drug === "no") {
        if(service.Group_Drug == 1 || service.Group_Alcohol == 1) {
            console.log("Users drugs/alcohol " + state.drug + " does not match service drug requirement");
            return false;
        } 
    }

    // Filter parent
    if(state.parent === "no") {
        if(service.Group_Parent == 1) {
            console.log("Users parent/carer " + state.parent + " does not match service parent/carer requirement");
            return false;
        }
    }

    // Filter care
    if(state.care === "no") {
        if(service.Group_LookedAfter == 1) {
            console.log("Users former in care " + state.parent + " does not match service former care requirement");
            return false;
        }
    }

    return true;
}

// Takes an array of filtered and sorted services, creates card components in target element
function appendResult(filterServices) {
    clearResults();

    for (const service of filterServices) {
        let card = createServiceCard(service);

        if(service.Stage1 > 0) {
            let stage1Container = document.querySelector("#stage1-results");
            stage1Container.appendChild(card);
        }

        if(service.Stage2 > 0) {
            let stage2Container = document.querySelector("#stage2-results");
            stage2Container.appendChild(card);
        }

        if(service.Stage3 > 0) {
            let stage3Container = document.querySelector("#stage3-results");
            stage3Container.appendChild(card);
        }

        if(service.Stage4 > 0) {
            let stage4Container = document.querySelector("#stage4-results");
            stage4Container.appendChild(card);
        }

        addVisibleTags(card, service);
    }
}

// Clears results from stage containers (prevents duplicate cards if answers are modified)
function clearResults() {
    let serviceCards = document.querySelectorAll("#stage1-results .service-card, #stage2-results .service-card, #stage3-results .service-card, #stage4-results .service-card");

    for (const card of serviceCards) {
        card.remove();
    }
}

// Takes a single service and returns a service card component
function createServiceCard(service) {
    let master = document.querySelector("#service-card-master > .service-card");
    let card = master.cloneNode(true);

    // Create header container
    let heading = card.querySelector(".heading-container > h3");

    // Add title
    heading.textContent = service.Title;

    // Add logo
    let logo = card.querySelector(".image-container > img");
    let src = service.Organisation.Logo;
    if(src.length > 0) {
        logo.setAttribute('src', 'https://www.smhn.org.uk/' + service.Organisation.Logo);
        logo.classList.add("active");
    }


    // Add organisation if available
    if(service.OrganisationID) {
        let orgHeading = document.createElement("span");
        heading.before(orgHeading);
        orgHeading.classList.add("active");
        orgHeading.textContent = service.Organisation.Name;
    }

    // Add card text
    let cardText = card.querySelector(".text-container > p");
    cardText.textContent = service.CardText;

    // Add phone if available
    if(service.ContactPhone) {
        let phoneListItem = card.querySelector(".icon-list-item.phone");
        let phoneLink = card.querySelector(".icon-list-item.phone > a");
        phoneListItem.classList.add("active");
        phoneLink.setAttribute("href", "tel:" + service.ContactPhone.trim());
    }

    // Add email if available
    if(service.ContactEmail) {
        let emailListItem = card.querySelector(".icon-list-item.email");
        let emailLink = card.querySelector(".icon-list-item.email > a");
        emailListItem.classList.add("active");
        emailLink.setAttribute("href", "mailto:" + service.ContactEmail);
    }

    // Add phone if available
    if(service.WebsiteLink) {
        let webListItem = card.querySelector(".icon-list-item.website");
        let webLink = card.querySelector(".icon-list-item.website > a");
        webListItem.classList.add("active");
        webLink.setAttribute("href", "https://" + service.WebsiteLink);
    }

    return card;
}

// Adds classes to tag container to display relevant tags
function addVisibleTags(card, service) {
    let tagContainer = card.querySelector(".tag-container");

    if(service.Group_Male) tagContainer.classList.add("male");
    if(service.Group_Female) tagContainer.classList.add("female");
    if(service.Group_Alcohol) tagContainer.classList.add("alcohol");
    if(service.Group_Drug) tagContainer.classList.add("drug");
    if(service.Group_Parent) tagContainer.classList.add("parent");
    if(service.Group_LookedAfter) tagContainer.classList.add("care");
    if(service.Group_CAMHS) tagContainer.classList.add("camhs");
    if(service.Inst_UoS) tagContainer.classList.add("uos");
    if(service.Inst_Solent) tagContainer.classList.add("solent");
    if(service.Inst_CityCollege) tagContainer.classList.add("citycollege");
    if(service.Inst_ItchenCollege) tagContainer.classList.add("itchencollege");
    if(service.Inst_RichardTaunton) tagContainer.classList.add("richardtaunton");
}

// Adds click events to the stage select buttons to switch between results
function setStageButtonClickEvents() {
    const stage1bttn = document.querySelector("#stage1-button");
    const stage2bttn = document.querySelector("#stage2-button");
    const stage3bttn = document.querySelector("#stage3-button");
    const stage4bttn = document.querySelector("#stage4-button");

    stage1bttn.addEventListener("click", function() { 
        setActiveResults(1);
    });

    stage2bttn.addEventListener("click", function() { 
        setActiveResults(2);
    });

    stage3bttn.addEventListener("click", function() { 
        setActiveResults(3);
    });

    stage4bttn.addEventListener("click", function() { 
        setActiveResults(4);
    });
}

// Changes active results based on stage button clicked, accepts stage value between 1 and 4
function setActiveResults(stage) {
    const resultsCard = document.querySelector('#exit_result');
    const resultsContainers = resultsCard.getElementsByClassName("result-container");
    let i = 0;

    for (const container of resultsContainers) {
        container.classList.remove("active");

        // Can assume containers always ordered stage 1-4
        const containerStage = i + 1;

        if(containerStage === stage) {
            resultsContainers[i].classList.add("active");
        }

        i += 1;
    }
}